<template>
    <div class="layout-person">
        <slot name="header">
            <div class="uk-section uk-section-medium uk-text-center uk-background-muted page-header">
              <div class="uk-light uk-container uk-container-small uk-text-center">

                  <router-link :to="parent.link" v-if="parent" class="text-green"><label>{{parent.menuTitle}}</label></router-link>
                  <h1 class="uk-margin-small-top">{{page.title}}</h1>

                  <h4 class="uk-margin-remove"><label class="text-blue">{{page.subtitle}}</label></h4>

                  <div class="uk-flex uk-flex-center uk-light uk-margin-top" uk-grid v-if="readFellowByURL.FacebookURL || readFellowByURL.TwitterURL || readFellowByURL.LinkedInURL">
                      <a :href="readFellowByURL.FacebookURL" class="uk-icon" uk-icon="facebook" target="_blank" v-if="readFellowByURL.FacebookURL"></a>
                      <a :href="readFellowByURL.TwitterURL" class="uk-icon" uk-icon="twitter" target="_blank" v-if="readFellowByURL.TwitterURL"></a>
                      <a :href="readFellowByURL.LinkedInURL" class="uk-icon" uk-icon="linkedin" target="_blank" v-if="readFellowByURL.LinkedInURL"></a>
                  </div>

              </div>
            </div>
        </slot>

        <div class="square uk-background-cover uk-card uk-card-default" v-bind:style="{ backgroundImage: `url(${page.image.smallSquare})` }" v-if="page.image && page.image.smallSquare" />

        <slot>
            <div class="uk-section uk-section-medium uk-background-white">
                <div class="uk-container uk-container-tiny uk-margin-bottom uk-margin-large-top">

                    <h3 v-if="page.summary" class="uk-text-center">
                        <em class="text-light-blue">{{page.summary}}</em>
                    </h3>
                </div>
                <div class="uk-container uk-container-small">
                    <div class="content" v-html="page.content"></div>
                </div>
            </div>
        </slot>

    </div>
</template>
<script>

import gql from 'graphql-tag'

// GraphQL query
const readFellowByURLQuery = gql`
    query($url: String!) {
      readFellowByURL(URL: $url){
        TwitterURL
        FacebookURL
        LinkedInURL
      }
    }
`

export default {
    props: ['page', 'parent'],
    data() {
        return {
            readFellowByURL: {}
        }
    },
    apollo: {
        readFellowByURL: {
            query: readFellowByURLQuery,
            variables() {
                return {
                    url: this.$route.path
                }
            }
        }
    }
}
</script>
